/* eslint-disable */
// import Swiper from "swiper/bundle";
// import { transform } from "lodash-es";
import Swiper from "swiper";

/* eslint-enable */

class HeroHomeSwiper {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$heroSection = this.sectionsContainer.querySelector('.hero-home-swiper');
		
		if (!this.$heroSection)
			return;
		
		this.sliderHeroSections = this.sectionsContainer.getElementsByClassName("swiper-hero-home");
		this.$heroSectionElements = this.$heroSection.querySelectorAll('.anima');
		this.$heroSectionImage = this.$heroSection.querySelectorAll('.content-image-slide .image');

		if (this.sliderHeroSections[0]) {
			this.init();
		}

		this.setAnimation();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		Array.from(this.sliderHeroSections).forEach((section) =>
			this.initSlider(section)
		);
	}

	setAnimation() {
        gsap.set(this.$heroSection, { opacity: 0.0001});
        gsap.set(this.$heroSectionElements, { yPercent: 20, opacity: 0.0001 });
		gsap.set(this.$heroSectionImage, {
			xPercent: 2, opacity: 0.0001, onComplete: () => {
				this.initAnimate();
		} });		
	}

	initAnimate() {
		this.animateHero = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$heroSection,
                start: 'top center',
			},
			onComplete: () => {
				gsap.set(this.$heroSectionElements, { clearProps: true });
				gsap.set(this.$heroSectionImage, { clearProps: true });
			}
        });
    
        this.animateHero.addLabel('step1');
        this.animateHero.to(this.$heroSection, { opacity: 1}, 'step1');
        this.animateHero.to(this.$heroSectionImage, { xPercent: 0, opacity: 1 }, 'step1+=0.3');
		this.animateHero.to(this.$heroSectionElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	
	initSlider(section) {
		this.swiperInstanceHero = new Swiper(section, {
			slidesPerView: 1,
			spaceBetween: '100%',
			navigation: {
				nextEl: '.swiperButtonHeroNext',
				prevEl: '.swiperButtonHeroPrev',
			},
			 pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,

			},
		});
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default HeroHomeSwiper;
